import styled, { css } from 'styled-components'

import { mediaQueries } from '@fourthwall/components'

export const Container = styled.div`
  display: flex;
  position: relative;
  justify-content: center;
  flex-direction: column-reverse;
  min-height: calc(100vh);

  ${mediaQueries.tablet} {
    height: 600px;
    min-height: auto;
    flex-direction: row;
  }
`

export const MainContent = styled.div`
  flex: 1;
  padding: var(--space-600);
  display: flex;
  flex-direction: column;

  ${mediaQueries.tablet} {
    padding: var(--space-700);
    max-width: 430px;
    min-width: 430px;
  }
`

export const SidebarContent = styled.div`
  display: flex;
  position: relative;

  ${mediaQueries.tablet} {
    flex: 1;
  }
`

export const HeaderContainer = styled.div`
  margin-bottom: var(--space-500);
  display: flex;
  align-items: center;
  gap: var(--space-400);
`

export const CloseButton = styled.button<{ variant: 'light' | 'dark' }>`
  position: absolute;
  top: var(--space-100);
  right: var(--space-100);
  z-index: 2;
  cursor: pointer;

  display: block;
  padding: var(--space-150);

  ${({ variant }) =>
    variant === 'light' &&
    css`
      color: var(--color-gray-200);
    `}

  ${({ variant }) =>
    variant === 'dark' &&
    css`
      color: var(--color-gray-800);
    `}
`

export const CenterContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: var(--space-300);
  text-align: center;

  ${mediaQueries.tablet} {
    padding: var(--space-700);
    max-width: 430px;
    min-width: 430px;
  }
`

export const LoaderWrapper = styled.div`
  margin-bottom: var(--space-200);
`
